import { DataNode } from 'antd/es/tree';
import { IDocument } from 'interfaces';
import AddNewConnectButton from '../components/AddNewConnectButton';
import { TreeDataNode } from 'antd';
import dayjs from 'dayjs';

const findItem = (treeTerms: IDocument[], key: string): any => {
  for (var i = 0; i < treeTerms.length; i++) {
      if (treeTerms[i].id === key) {
      return treeTerms[i]
    } else if (treeTerms[i].children) {
      const findedInTree = findItem(treeTerms[i].children || [], key);
      if (findedInTree) return findedInTree;
    };
  };
};

export const findParentTerm = (relatedTerms: IDocument[], key: string): any => {
  for (var i = 0; i < relatedTerms.length; i++) {
      const childrenIds = relatedTerms[i].children?.map(el => el.id);      
      if (childrenIds?.includes(key)) {
      return relatedTerms[i]
    } else if (relatedTerms[i].children) {
      const findedInTree = findItem(relatedTerms[i].children || [], key);
      if (findedInTree) return findedInTree;
    };
  };
};

export const updateTreeData = (list: DataNode[], key: React.Key, children: DataNode[], treeTerms: IDocument[], permission?: boolean): DataNode[] =>
  list.map(node => {
    if (node.key === key) {
      const firstChildrenPosition = String(children[0]?.key)?.split('_')[0]; 
      const lastChildrenPosition = String(children[children.length - 1]?.key)?.split('_')[0];
      const childrendWithExtraElements = children;
      const targetTerm = findItem(treeTerms, String(key).split('_')[1]);

      if (firstChildrenPosition !== 'create') {
        childrendWithExtraElements.unshift({
          key: `create_${node.key}`,
          title: <AddNewConnectButton targetTerm={targetTerm} disabled={!Boolean(permission)}/>,
          isLeaf: true,
        })
      };
      if (lastChildrenPosition !== 'footer') {
        childrendWithExtraElements.push({ key: `footer_${node.key}`, isLeaf: true, style: { display: 'none' } })
      };
    
      return {
        ...node,
        isLeaf: false, //childrendWithExtraElements[0] ? false : true,
        children: childrendWithExtraElements,
      };
    }
    if (node.children) {
      return {
        ...node,
        isLeaf: false, //updateTreeData(node.children, key, children, treeTerms, permission)[0] ? false : true,
        children: updateTreeData(node.children, key, children, treeTerms, permission),
      };
    }
  return node;
  }
);

export const addChildrenFunction = (term: IDocument, key: string, activeChildren: IDocument[]): IDocument => {
  if (term.id === key) return {...term, children: activeChildren};
  if (term.children) {
    return {
      ...term,
      children: term.children.map((anotherTerm: IDocument) => addChildrenFunction(anotherTerm, key, activeChildren))
    }
  }
  return term;
};

export const deleteTreeItem = (treeTerms: TreeDataNode[], key: string): TreeDataNode[] => {  
  return treeTerms.filter(term => String(term.key).split('_')[1] !== key).map(item =>{
    if (item.children) {
      return {
        ...item,
        children: deleteTreeItem(item.children, key)
      }
    } else {
      return item
    }
  });
};

export const deleteTermItem = (arrTerms: IDocument[], key: string): IDocument[] => {
  return arrTerms.filter(term => term.id !== key).map(item => {
    if (item.children) {
      return {
        ...item,
        children: deleteTermItem(item.children, key)
      }
    } else {
      return item
    }
  });
};

export const changeStatusTerm = (arrTerms: IDocument[], key: string, status: string): IDocument[] => {
  const UTCDate = dayjs().valueOf() + new Date().getTimezoneOffset() * 60 * 1000;
  
  return arrTerms.map(item => {
    if (item.id === key) {
      return {
        ...item,
        user_status: {
          ...item.user_status!,
          accepted_at: UTCDate,
          status_access: status
        }
      }
    } else {
      if (item.children) {
        return {
          ...item,
          children: changeStatusTerm(item.children, key, status)
        }
      } else {
        return item;
      }
    }
  });
};
